import { ALL_GEOGRAPHIES } from './JceHomepageGeographyListRoute';
import { Button } from 'ui';
import {
  DEFAULT_GEOGRAPHY_FORM_VALUES,
  JceGeographyAttributesForm,
  JceHomepageGeographyFormValues,
} from 'components/jceGeographyDetail/JceGeographyAttributesForm';
import { gql } from '@apollo/client';
import { useCreateJceHomepageGeographyMutation } from 'generated/graphql';
import { useNavigate } from 'react-router-v7';
import ClowncarBodyV2 from 'components/ClowncarBodyV2';
import ClowncarHeaderV2 from 'components/ClowncarHeaderV2';
import React from 'react';

gql`
  mutation CreateJceHomepageGeography($geography: JceHomepageGeographyInput!) {
    createJceHomepageGeography(geography: $geography) {
      id
      name
      urlSlug
      resyBlogKey
      tier
      priorityWithinTier
    }
  }
`;

const JceHomepageGeographyFormRoute: React.FC = () => {
  const [createGeography] = useCreateJceHomepageGeographyMutation();
  const navigate = useNavigate();

  const onSubmit = async (values: JceHomepageGeographyFormValues) => {
    await createGeography({
      variables: {
        geography: {
          name: values.name,
          urlSlug: values.urlSlug,
          resyBlogKey: values.resyBlogKey,
          tier: values.tier,
          priorityWithinTier: values.priorityWithinTier,
        },
      },
      refetchQueries: [{ query: ALL_GEOGRAPHIES }],
    }).then((resp: { errors?: unknown }) => {
      if (!resp.errors) {
        navigate('/jce-homepage-geography');
      }
    });
  };

  return (
    <div className="Content">
      <ClowncarHeaderV2
        heading="Create JCE Homepage Geography"
        actions={
          <Button variant="outlined" onClick={() => navigate(-1)}>
            ← Back
          </Button>
        }
      />
      <ClowncarBodyV2>
        <JceGeographyAttributesForm
          initialValues={DEFAULT_GEOGRAPHY_FORM_VALUES}
          onSubmit={onSubmit}
          submitLabel="Create"
        />
      </ClowncarBodyV2>
    </div>
  );
};

export default JceHomepageGeographyFormRoute;
